var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5 16.5623V66.656C36.9688 66.656 36.4062 66.5623 35.9688 66.3123L35.8438 66.2498C29.8438 62.9685 19.375 59.531 12.5938 58.6248L11.6875 58.4998C8.6875 58.1248 6.25 55.3123 6.25 52.3123V14.5623C6.25 10.8435 9.28125 8.03105 13 8.34355C19.5625 8.8748 29.5 12.1873 35.0625 15.656L35.8438 16.1248C36.3125 16.406 36.9062 16.5623 37.5 16.5623Z",
    fill: "#FF5364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 14.5938V52.3125C68.75 55.3125 66.3125 58.125 63.3125 58.5L62.2812 58.625C55.4688 59.5313 44.9688 63 38.9688 66.3125C38.5625 66.5625 38.0625 66.6563 37.5 66.6563V16.5625C38.0938 16.5625 38.6875 16.4063 39.1562 16.125L39.6875 15.7813C45.25 12.2813 55.2188 8.93753 61.7813 8.37503H61.9688C65.6875 8.06253 68.75 10.8438 68.75 14.5938Z",
    fill: "#FF5364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 28.875H17.1875C15.9062 28.875 14.8438 27.8125 14.8438 26.5312C14.8438 25.25 15.9062 24.1875 17.1875 24.1875H24.2188C25.5 24.1875 26.5625 25.25 26.5625 26.5312C26.5625 27.8125 25.5 28.875 24.2188 28.875Z",
    fill: "#FF5364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 38.25H17.1875C15.9062 38.25 14.8438 37.1875 14.8438 35.9062C14.8438 34.625 15.9062 33.5625 17.1875 33.5625H26.5625C27.8438 33.5625 28.9062 34.625 28.9062 35.9062C28.9062 37.1875 27.8438 38.25 26.5625 38.25Z",
    fill: "#FF5364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon08);
export default __webpack_public_path__ + "static/media/icon-08.1703d76546949697abad31ebcd404e99.svg";
export { ForwardRef as ReactComponent };